import { IsArray, IsNumber, IsOptional, IsString } from 'class-validator';

export class CompaniesDto {
    @IsString()
    @IsOptional()
    name?: string;

    @IsString()
    id: string;

    @IsString()
    @IsOptional()
    founded?: number;

    @IsString()
    @IsOptional()
    website?: string;

    @IsString()
    @IsOptional()
    size?: string;

    @IsNumber()
    @IsOptional()
    pdl_current_size?: number;

    @IsNumber()
    @IsOptional()
    pdl_historic_size?: number;

    @IsOptional()
    employee_counts?: any;

    @IsString()
    @IsOptional()
    locality?: string;

    @IsString()
    @IsOptional()
    region?: string;

    @IsString()
    @IsOptional()
    street_address?: string;

    @IsString()
    @IsOptional()
    country?: string;

    @IsString()
    @IsOptional()
    industry?: string;

    @IsArray()
    tags?: string[];

    @IsArray()
    description?: string[];

    @IsString()
    @IsOptional()
    linkedin_url?: string;

    @IsString()
    @IsOptional()
    facebook_url?: string;

    @IsString()
    @IsOptional()
    twitter_url?: string;

    @IsString()
    @IsOptional()
    crunchbase_url?: string;

    constructor(iCompanies: CompaniesDto) {
        this.name = iCompanies.name;
        this.id = iCompanies.id;
        this.founded = iCompanies.founded;
        this.website = iCompanies.website;
        this.size = iCompanies.size;
        this.pdl_current_size = iCompanies.pdl_current_size;
        this.pdl_historic_size = iCompanies.pdl_historic_size;
        this.employee_counts = iCompanies.employee_counts;
        this.locality = iCompanies.locality;
        this.region = iCompanies.region;
        this.street_address = iCompanies.street_address;
        this.country = iCompanies.country;
        this.industry = iCompanies.industry;
        this.tags = iCompanies.tags;
        this.description = iCompanies.description;
        this.linkedin_url = iCompanies.linkedin_url;
        this.facebook_url = iCompanies.facebook_url;
        this.twitter_url = iCompanies.twitter_url;
        this.crunchbase_url = iCompanies.crunchbase_url;
    }
}

export type ValidatedName = { queryString: string; suggestion: CompaniesDto };
